import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=673b2b66&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=673b2b66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b2b66",
  null
  
)

export default component.exports